/**
 * 준비중 페이지 — 실시간 시세 비활성화 기간 동안 /market, /virtual 등에 노출.
 * 법인 전환 후 각 페이지 컴포넌트로 되돌리면 이 페이지 사용 처도 함께 제거.
 */
import { Link } from 'react-router-dom';

interface ComingSoonPageProps {
  /** 표시 제목 (예: '실시간 시세', '모의투자') */
  title?: string;
  /** 보조 설명 */
  description?: string;
}

export function ComingSoonPage({
  title = '준비중이에요',
  description = '법인 전환 이후 다시 제공될 예정이에요.',
}: ComingSoonPageProps) {
  return (
    <div className="container-base flex min-h-[60vh] flex-col items-center justify-center py-10 text-center">
      <div className="rounded-2xl border border-dashed border-[var(--color-border)] bg-[var(--color-surface)] px-8 py-14 max-w-lg w-full">
        <h1 className="text-2xl font-extrabold">{title}</h1>
        <p className="mt-3 text-sm text-[var(--color-text-sub)] leading-relaxed whitespace-pre-line">
          {description}
        </p>
        <div className="mt-6 flex flex-col items-center gap-1.5 text-xs text-[var(--color-text-sub)]">
          <p>그동안 다른 게시판에서 이야기 나눠요.</p>
        </div>
        <Link
          to="/"
          className="mt-6 inline-flex items-center justify-center rounded-full bg-[var(--color-primary)] px-5 py-2 text-sm font-semibold text-white hover:bg-[var(--color-primary)]/90"
        >
          홈으로
        </Link>
      </div>
    </div>
  );
}
